import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { MobileAdvanceRequestDetailReportSchemaObject } from "../MobileAdvanceRequestDetailReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';
import MaterialTable from "material-table";
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CleaningServices } from "@mui/icons-material";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import DoneIcon from '@material-ui/icons/Done';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import $, { data } from "jquery";
import MessageModal from '../../../../UI/Modal/MessageModal';
import { DataGrid } from '@mui/x-data-grid';
const screenCode = "MOBILEADVANCEREQUESTDETAILREPORT";

export function MobileAdvanceRequestDetail(props) {
  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });
  const componentRef = useRef();
  const classes = useStyles();

  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [gtnnumber, setGtnnumber] = useState([]);
  const [isTableHide, setIsTableHide] = useState(true);
  const [taskCategory, setTaskCategory] = useState();
  const [labourTask, setLabourTask] = useState();

  const [mobileAdvanceRequestDetail, setMobileAdvanceRequestDetail] = useState({
    groupID: "0",
    estateID: "0",
    divisionID: "0",
    //month: "",
    supNo: "",
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    group: "0",
    estate: "0",
    division: "0",
    //month: "",
    supNo: "",
  })
  const [rejectData, setRejectData] = useState({
    approvedAdvanceDetailsID: "",
    statusID: "",
  });

  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success"
  })
  const [open, setOpen] = React.useState(false);
  const [openReject, setOpenReject] = React.useState(false);
  const [csvData, setCsvData] = useState([]);

  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
  const [buttonHide, setButtonHide] = useState(true);

  const schema = Joi.object(MobileAdvanceRequestDetailReportSchemaObject).options({ allowUnknown: true });
  const contentRowNames = ["pmtNo", "dedDate", "pmtDate", "lineName", "supNo", "supName", "paidBy", "amount", "sign"]
  const csvHeaders = [
    { label: "Pmt No", value: "pmtNo" },
    { label: "Ded Date", value: "dedDate" },
    { label: "Pmt Date", value: "pmtDate" },
    { label: "Line Name", value: "lineName" },
    { label: "Sup No", value: "supNo" },
    { label: "Sup Name", value: "supName" },
    { label: "Paid By", value: "paidBy" },
    { label: "Amount", value: "amount" },
    { label: "Sign", value: "sign" }

  ];

  const [reportData, setReportData] = useState([]);
  const [reportDataOne, setReportDataOne] = useState([]);
  const [keys, setKeys] = useState([]);
  const [ApprovedRequest, setApprovedRequest] = useState();
  const [SelectedRecords, setSelectedRecords] = useState([]);
  useEffect(() => {
    trackPromise(getPermissions(),
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getEstatesForDropdown()
    )
  }, [mobileAdvanceRequestDetail.groupID])

  useEffect(() => {
    trackPromise(
      getDivisionsForDropDown(),
      getTaskNames(),
      getLabourTask()

    )
  }, [mobileAdvanceRequestDetail.estateID])

  useEffect(() => {
    trackPromise(
      getDivisionsForDropDown(),
      getLabourTask()

    )
  }, [mobileAdvanceRequestDetail.category])


  function handleGroupChange(target) {
    validateInputs(target);

    setMobileAdvanceRequestDetail({
      ...mobileAdvanceRequestDetail,
      groupID: target.value,
      estateID: "0",
      divisionID: "0"

    });
  }

  function handleEstateChange(target) {
    validateInputs(target);

    setMobileAdvanceRequestDetail({
      ...mobileAdvanceRequestDetail,
      estateID: target.value,
      divisionID: "0"

    });
  }

  function handleDivisionChange(target) {
    setMobileAdvanceRequestDetail({
      ...mobileAdvanceRequestDetail,
      divisionID: target.value

    });
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true })
  }

  async function handleApprove1(e) {
    var approvedlist = [];
    SelectedRecords.forEach(element => {
      var model = {
        approvedAdvanceDetailsID: parseInt(element),
        statusID: 1,
      };
      approvedlist.push(model)
    });

    const response = await services.ApproveAdvanceRequestStatusUpdate(approvedlist);

    if (response.statusCode == "Success") {

      setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
    }
    else {

    }
    handleSearch();
    setOpen(false);
  }

  async function handleReject1(e) {
    var model = {
      approvedAdvanceDetailsID: parseInt(rejectData.approvedAdvanceDetailsID),
      statusID: parseInt(rejectData.statusID),
    };
    const response = await services.ApproveAdvanceRequestRejectStatusUpdate(model);
    if (response.statusCode == "Success") {

      setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
    }
    else {

    }
    handleSearch();
    setOpenReject(false);
  }

  function handleReject(ignoreSession) {
    props.history.push({
      pathname: setOpenReject(true),
      edit: true,
    });
    setRejectData(ignoreSession);
  }

  function handleApprove(approveSession) {
    props.history.push({
      pathname: setOpen(true),
      edit: true,
    });
    setApprovedRequest(approveSession)
  }

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClickOpen2() {
    setOpenReject(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function handleClose2() {
    setOpenReject(false);
  }

  function clearState(e) {
    setMobileAdvanceRequestDetail({
      ...mobileAdvanceRequestDetail,
      groupID: "",
      estateID: "",
      divisionID: "",
      //month:"",
      supNo: "",
    });
    setIsTableHide(true);
  }

  function onClearClick() {
    clearState();
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, MobileAdvanceRequestDetailReportSchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }


  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWMOBILEADVANCEREQUESTDETAILREPORT');

    if (isAuthorized === undefined) {
      props.history.push('/unauthorized');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

    var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();

    setMobileAdvanceRequestDetail({
      ...mobileAdvanceRequestDetail,
      groupID: token.groupID,
      estateID: token.operationEntityID
    });

    trackPromise(getGroupsForDropdown());
  }


  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const result = await services.GetAllOperationEntityByGroupID(mobileAdvanceRequestDetail.groupID);
    setEstates(result);
  }

  async function getDivisionsForDropDown() {
    const data = await services.getDivisionByEstateID(mobileAdvanceRequestDetail.estateID);
    setDivisions(data);
  }

  async function getTaskNames() {
    const result = await services.getAllTaskNames(mobileAdvanceRequestDetail.groupID, mobileAdvanceRequestDetail.estateID);
    setTaskCategory(result);
  }

  async function getLabourTask() {
    const result = await services.getLabourTaskByOperationEntityIDTaskCategoryID(mobileAdvanceRequestDetail.estateID)
    setLabourTask(result)
  }


  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleTaskNameChange(target) {

    setMobileAdvanceRequestDetail({
      ...mobileAdvanceRequestDetail,
      supNo: target.value,
    });
  }

  function handleChange(e) {
    const target = e.target;

    const value = target.type === "checkbox" ? target.checked : target.value;
    setMobileAdvanceRequestDetail({
      ...mobileAdvanceRequestDetail,
      [e.target.name]: value,
    });
  }

  async function handleSearch(e) {

    getSelectedDropdownValuesForReport(mobileAdvanceRequestDetail);

    setIsTableHide(true);

    const result = await services.GetAdvanceRequestReportDetail(mobileAdvanceRequestDetail);
    // let groupedResult = groupByGtn(result);
    // let keys = Object.keys(groupedResult);
    // setKeys(keys);


    setReportDataOne(result);

    if (result.length > 0) {

      result.forEach(x => {
        x.dedDate = x.dedDate.split('T')[0];
        x.pmtDate = x.pmtDate.split('T')[0];
        x.amount = parseFloat(x.amount).toFixed(2);
      })
      setIsTableHide(false);
      setIsReportButtonsEnabled(true);
    } else {
      setIsReportButtonsEnabled(false);
    }

    setReportData(result);
    setButtonHide(false);
    setIsReportButtonsEnabled();

    const comlpeteData = [...result];
    setCsvData(comlpeteData)
  }

  function createFile() {
    var settings = {
      sheetName: 'Mobile Advance Request Detail',
      fileName: 'MobileAdvanceRequestDetailReport',
      writeOptions: {}
    }
    var copyOfCsv = _.cloneDeep(csvData)
    var newRow1 = {
      pmtNo: "Group :" + groups[mobileAdvanceRequestDetail.groupID],
      dedDate: "Operation Entity : " + estates[mobileAdvanceRequestDetail.estateID],
      //pmtDate: "Date : " + mobileAdvanceRequestDetail.month,
      lineName: "Generated date/time : " + new Date().toLocaleString(),
      supNo: "Generated user : " + tokenService.getUserNameFromToken()
    }
    copyOfCsv.push({}, {}, newRow1)
    xlsx(csvHeaders, copyOfCsv, settings, true)
  }


  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchForm.groupID],
      estate: estates[searchForm.estateID],
      division: divisions[searchForm.divisionID],
      supNo: searchForm.supNo,
      //month: searchForm.month
    })
  }

  function groupByGtn(objectArray) {
    return objectArray.reduce(function (acc, obj) {
      let key = obj['gtnNumber']
      if (!acc[key]) {
        acc[key] = []
      }
      acc[key].push(obj)
      return acc
    }, {})
  }

  const columns = [
    {
      field: 'pmtNo',
      headerName: 'Pmt No.',
      editable: true,
      width: 150
    },
    {
      field: 'dedDate',
      headerName: 'Ded Date',
      editable: true,
      width: 150
    },
    {
      field: 'pmtDate',
      headerName: 'Pmt Date',
      editable: true,
      width: 150
    },
    {
      field: 'lineName',
      headerName: 'Line Name',
      editable: true,

      width: 150
    },
    {
      field: 'supNo',
      headerName: 'Sup No.',
      editable: true,
      width: 150
    },
    {
      field: 'supName',
      headerName: 'Paid By',
      editable: true,
      width: 150
    },
    {
      field: 'amount',
      headerName: 'Amount',
      editable: true,
      width: 150
    },
    {
      field: 'age',
      headerName: 'Sign',
      editable: true,
      width: 150
    },
  ];

  function handleSelect(data) {
    console.log("dataxx", data);
  }

  // { title: 'Pmt No.', field: 'pmtNo',headerStyle: { fontWeight: "bold" } },
  // { title: 'Ded Date', field: 'dedDate' ,headerStyle: { fontWeight: "bold" } },
  // { title: 'Pmt Date', field: 'pmtDate',headerStyle: { fontWeight: "bold" }  },
  // { title: 'Line Name', field: 'lineName',headerStyle: { fontWeight: "bold" }  },
  // { title: 'Sup No.', field: 'supNo' ,headerStyle: { fontWeight: "bold" } },
  // { title: 'Paid By', field: 'supName',headerStyle: { fontWeight: "bold" }  },
  // { title: 'Amount', field: 'amount',headerStyle: { fontWeight: "bold" }  },
  // { title: 'Sign', field: 'sign',headerStyle: { fontWeight: "bold" }  }
  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">

            <PageHeader
              title="Mobile Advance Request Detail Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form
                onSubmit={(e) => handleSearch(e)}
                disabled={false}
              >
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">Group *</InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={mobileAdvanceRequestDetail.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={mobileAdvanceRequestDetail.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(estates)}
                    </Select>
                    {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="divisionID">Collection Point *</InputLabel>
                    <Select
                      fullWidth
                      labelId="divisionID"
                      id="divisionID"
                      name="divisionID"
                      value={mobileAdvanceRequestDetail.divisionID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                    {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="supNo">
                      Sup No.
                    </InputLabel>
                    <TextField
                      fullWidth
                      name="supNo"
                      id="supNo"
                      value={mobileAdvanceRequestDetail.supNo}
                      type="text"
                      onChange={(e) => handleTaskNameChange(e.target)}
                    />
                  </div>
                </div>


                <div className="row">

                  {/* <div className="col-md pb-1">
                                        <TextField
                                            id="month"
                                            label="Month *"
                                            name="month"
                                            type="month"
                                            fullWidth
                                            value={mobileAdvanceRequestDetail.month}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                    </div> */}
                </div>

                <div className="card-footer">
                  <div className="col-md pb-1">
                    <input
                      type="button"
                      className="btn btn-primary"
                      value="Search"
                      onClick={e => trackPromise(handleSearch(e))}
                    />
                    <input
                      type="button"
                      className="btn btn-warning pull-right"
                      value="Clear"
                      onClick={onClearClick}
                    />
                  </div>
                </div>
              </form>

              {isTableHide ? null :
                <div style={{ width: '100%' }}>
                  <DataGrid
                    rows={reportData}
                    columns={columns}
                    pageSize={5}
                    checkboxSelection
                    getRowId={(row => row.approvedAdvanceDetailsID)}
                    onRowSelectionModelChange={(ids) => {
                      setSelectedRecords(ids);
                    }}
                    disableSelectionOnClick
                  />
                

                  <div>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleClickOpen}
                      hidden={true}
                    >
                      Open alert dialog
                    </Button>
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">{"Approve"}</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          Are you sure you want to Approve this record?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleClose} color="primary">
                          No
                        </Button>
                        <Button onClick={handleApprove1} color="primary" autoFocus>
                          Yes
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>

                  <div>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleClickOpen2}
                      hidden={true}
                    >
                      Open form dialog
                    </Button>
                    <Dialog
                      open={openReject}
                      onClose={handleClose2}
                      aria-labelledby="form-dialog-title"
                    >
                      <DialogTitle id="form-dialog-title">Reject</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Are you sure you want to Reject these selected records?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleClose2} color="primary">
                          No
                        </Button>
                        {<Button onClick={handleReject1} color="primary">
                          Yes
                        </Button>}
                      </DialogActions>
                    </Dialog>
                  </div>

                  <div>
                    <div className="pt-2">
                      <input
                        type="button"
                        className="btn btn-primary pull-right ml-2"
                        value="Approve"
                        onClick={handleApprove}
                        disabled={SelectedRecords != 0 ? false : true}

                      />

                      <input
                        type="button"
                        className="btn btn-primary pull-right ml-2"
                        value="Reject"
                        onClick={handleReject}
                      />
                    </div>

                  </div>

                </div>

              }
            </div>
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>

  );
}

